import React from 'react';
import './home.css'
import Sec1home from '../sections/sec1_main_home.jsx';

const Home = () => {
    return ( 
        <>
            <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Sec1home />
            </section>
        </>
     );
}
 
export default Home;